import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-19611192"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "course-card-cover"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = ["title"];
const _hoisted_7 = {
  key: 1,
  class: "course-name text-overflow",
  id: "courseName"
};
const _hoisted_8 = {
  class: "bottom"
};
const _hoisted_9 = {
  class: "teacher"
};
const _hoisted_10 = ["title"];
const _hoisted_11 = ["title"];
const _hoisted_12 = {
  class: "time"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goDetail && $options.goDetail(...args)),
    class: "course-card"
  }, [$props.showResultTag && $props.courseData.results_id ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: "tag-btn",
    style: _normalizeStyle({
      background: $props.resultMap[$props.courseData.results_id]
    })
  }, _toDisplayString($props.courseData.results_name), 5)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $props.courseData.course_cover_url || require('@/assets/images/common/course_cover.png')
  }, null, 8, _hoisted_4)]), $props.courseData.classify_name ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", {
    class: "course-name text-overflow",
    title: $props.courseData.course_name.length > 15 ? $props.courseData.course_name : '',
    id: "courseName"
  }, _toDisplayString($props.courseData.course_name), 9, _hoisted_6)])) : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($props.courseData.course_name), 1))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: "name texts",
    title: $props.courseData.lecturer.length > 10 ? $props.courseData.lecturer : ''
  }, _toDisplayString($props.courseData.lecturer || "暂无"), 9, _hoisted_10), _createElementVNode("div", {
    class: "name ml",
    title: $props.courseData.classify_name && $props.courseData.classify_name.length > 16 ? $props.courseData.classify_name : ''
  }, _toDisplayString($props.courseData.classify_name || '暂无'), 9, _hoisted_11)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, _toDisplayString($props.courseData.students_num || 0) + "人参加", 1)])])])]);
}